import React from "react";
import "../../static/css/ChatWindow.css"; 

interface TypingIndicatorProps {
  modelName?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ modelName }) => {
  return (
    <div className="typing-indicator">
      {modelName && <div className="model-name">{modelName}</div>}
      <div className="typing-dots">
        <div className="typing-dot"></div>
        <div className="typing-dot"></div>
        <div className="typing-dot"></div>
      </div>
    </div>
  );
};

export default TypingIndicator;